/**
 * Decides whether a PathSelector input is in a valid ("not an error") state.
 *
 * Empty input is neutral — the user has not yet typed anything, so there is
 * nothing to fail to match. An error is only shown when the user (or a saved
 * layout's `initialInputValue`) has supplied text that fails to resolve.
 *
 * @param isValidFreeText whether the consumer can mean something by text that
 *   names no path — a joint binding reads a finite number as a fixed pose, and
 *   flagging `0.5` as "no matching data found" would call a perfectly good value
 *   an error. Defaults to false, so a selector that only ever meant a path is
 *   judged exactly as before, and a *typo* still reads as an error even in a
 *   field that takes both.
 */
export function isPathInputValid(
  inputValue: string,
  matchCount: number,
  isValidFreeText = false,
): boolean {
  return inputValue.length === 0 || matchCount > 0 || isValidFreeText;
}
